import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import CircleSector from 'components/common/CircleSector';

interface IProps {
  src: string;
  backgroundPosition?: string;
  backgroundColor?: string;
  imageMaxWidth?: number;
}

interface StyleProps {
  imageMaxWidth?: number;
}

const useStyles = makeStyles<StyleProps>()((_, params) => ({
  root: {
    position: 'relative',
  },
  imageContainer: {
    position: 'relative',
  },
  image: {
    width: '100%',
  },
  centerImage: {
    maxWidth: params?.imageMaxWidth || 588,
  },
}));

const PromoProgramsPicture: React.FC<React.PropsWithChildren<IProps>> = ({
  src,
  backgroundPosition = 'pie',
  backgroundColor,
  imageMaxWidth,
}) => {
  const { classes } = useStyles({ imageMaxWidth });

  const picture = {
    full: (
      <div className={classes.imageContainer} {...(backgroundColor && { style: { backgroundColor } })}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className={classes.image} src={src} alt={src} />
      </div>
    ),
    pie: (
      <CircleSector
        radius={450}
        variant="top-left"
        position="relative"
        backgroundSize="cover"
        backgroundPosition={backgroundPosition}
        backgroundImage={`url(${src})`}
      />
    ),
    center: (
      <div className={classes.centerImage}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className={classes.image} src={src} alt={src} />
      </div>
    ),
  };
  return <div className={classes.root}>{picture[backgroundPosition as keyof typeof picture]}</div>;
};

export default memo(PromoProgramsPicture);
